import { BehaviorSubject, Observable, Observer, empty } from 'rxjs';
import { debounceTime, tap, switchMap } from 'rxjs/operators';
import { cancelableFetch } from './cancelableFetch';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export const IDLE = '[HttpRequestStream] Idle';
export const START = '[HttpRequestStream] Start';
export const FETCHING = '[HttpRequestStream] Fetching';

// tslint:disable:no-any

export class HttpRequestStream<Payload = any, Response = any> {

  private payload = new BehaviorSubject<Payload|null>(null);
  private cancel?: () => void;
  public state = new BehaviorSubject(IDLE);
  public outlet: Observable<any> = this.payload.pipe(
    tap((next) => { 
      this.state.next(START);
      if (this.cancel) {
        this.cancel();
        this.cancel = undefined;
      }
    }),
    debounceTime(this.debounce),
    switchMap((params) => {

      if (!params) {
        return empty();
      }
      const h = this.headers || new Headers();
      h.append('Content-Type', 'application/json');

      this.state.next(FETCHING);
      const { promise, cancel } = cancelableFetch(
        fetch(`${baseUrl}/${this.url}`, {
          body: JSON.stringify(params),
          headers: h,
          method: this.method,
          mode: 'cors'
        })
      );

      this.cancel = cancel;
      
      return Observable.create((observer: Observer<Response>) => {
        promise.then((fetch) => {
          const response = (fetch.json && fetch.json()) || fetch;

          response.then((output) => {
            this.state.next(IDLE);
            observer.next(output);
            observer.complete();
          }).catch(observer.error);
          
        }).catch(() => {
          this.state.next(IDLE);
          observer.complete();
        });
      });
    })
  );

  constructor(
    private url: string, 
    private method: string = 'POST', 
    private headers?: Headers,
    private debounce: number = 500
  ) { }
  
  public send(params: Payload | null) {
    this.payload.next(params);
  }
}

// tslint:enable:no-any
